import { MESSAGES } from 'portal/src/constants/snackbarMessages';
import { ValidatorBody } from 'portal/src/validators/validateGuard';

export class BillFormValidators {
  getValues;
  lineItems;

  constructor(getValues, lineItems) {
    this.getValues = getValues;
    this.lineItems = lineItems;
  }

  /**
   * Warning validators array that contains the warning message and the validator function,
   * the validator function return a tuple [isValid, nextValidatorObject],
   * finally contain the next function, that work similar to middleware action.
   * @param hasUnsavedLineItemEdits whether any line item row is in edit mode
   * @param next on success function
   * @returns {Array<ValidatorBody | { next }>}
   */
  getWarningsValidators(
    hasUnsavedLineItemEdits: boolean,
    next: () => void,
  ): Array<ValidatorBody<[boolean, ValidatorBody<[]>]> | { next: () => void }> {
    const validators = [
      {
        message:
          'Warning: you entered the same start and end date for the bill and/or line items.',
        validate: () => {
          const values = this.getValues();
          const { startDate, endDate } = values;
          const similarDate = startDate.getTime() === endDate.getTime();
          const lineItem = this.lineItems.some(
            ({ startDate, endDate }) =>
              new Date(startDate).getTime() === new Date(endDate).getTime(),
          );
          return [!(similarDate || lineItem), validators[1]];
        },
      },
      {
        message:
          'Warning: you have unsaved line items. Do you want to save the bill or go back to editing it?',
        validate: () => [!hasUnsavedLineItemEdits, validators[2]],
      },
      { next },
    ];
    return validators;
  }

  /**
   * Return an array validator to guards control with validate function that return a single boolean
   * @param total
   * @returns {Array<ValidatorBody<boolean>>}
   */
  getLineItemsValidator(total): ValidatorBody<boolean | Promise<boolean>>[] {
    const values = this.getValues();
    return [
      {
        message: MESSAGES.LINE_ITEM.ONE_REQUIRED,
        validate: () => this.lineItems.length > 0,
      },
      {
        message: MESSAGES.LINE_ITEM.TOTAL_ERROR,
        validate: () =>
          !!this.lineItems.length && parseFloat(values.amount) === total,
      },
    ];
  }
}
